module.exports = __webpack_public_path__ + "static/media/Vector (5).13697d6f.svg";